import {
    Box,
    Typography,
    Button,
    TextField,
    Paper,
    Stack
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { assignQr } from "../../../services/api";
import jsQR from "jsqr";
import JsQrCameraScanner from "./JsQrCameraScanner";


const Container = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #f5f7fa, #e4ecf7)"
});

const ScannerCard = styled(Paper)({
    width: 360,
    padding: 24,
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
});

const CameraFrame = styled(Box)({
    width: "100%",
    aspectRatio: "1",
    borderRadius: 12,
    overflow: "hidden",
    border: "2px dashed #1976d2",
    marginBottom: 16
});

const QrScanner = ({ handleCloseCamera, landmarkData }) => {
    const [data, setData] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (data) {
            const asignCode = async () => {
                let code = data?.split("/qr/")[1]
                let resp = await assignQr({
                    buildingId: landmarkData?.building_ID,
                    landmarkId: landmarkData._id,
                    code
                })

                if (resp.status === 200) alert("qr assigned successfully")
            }
            asignCode()
        }
    }, [data]);

    function invertImage(imageData) {
    const d = imageData.data;
    for (let i = 0; i < d.length; i += 4) {
        d[i] = 255 - d[i];       // R
        d[i + 1] = 255 - d[i + 1]; // G
        d[i + 2] = 255 - d[i + 2]; // B
    }
}

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            // Try normal decode
            let code = jsQR(imageData.data, imageData.width, imageData.height);

            // If failed, try inverted colors (helps for blue/low-contrast QR)
            if (!code) {
                invertImage(imageData);
                code = jsQR(imageData.data, imageData.width, imageData.height);
            }

            if (code) {
                setData(code.data);   // same as result.getText()
            } else {
                alert("No QR code detected in image");
            }
        };
    };


    return (
        <Container>
            <ScannerCard>
                <Stack spacing={2}>
                    <Box textAlign="center">
                        <Typography variant="h6" fontWeight={600}>
                            Scan QR Code
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Use camera or upload an image
                        </Typography>
                    </Box>

                    {/* Camera Scanner */}
                    <CameraFrame>
                        {/* <QrReader
                            constraints={{ facingMode: "environment" }}
                            onResult={(result) => {
                                if (result) setData(result.text);
                            }}
                            style={{ width: "100%" }}
                        /> */}
                        <JsQrCameraScanner
                            setData={setData}
                            invertImage={invertImage}
                        />
                    </CameraFrame>

                    {data && (
                        <Typography
                            variant="body2"
                            color="success.main"
                            textAlign="center"
                        >
                            {data} - {landmarkData?._id}
                        </Typography>
                    )}

                    {/* Hidden File Input */}
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleImageUpload}
                    />

                    <Stack direction="row" spacing={1}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload Image
                        </Button>

                        <Button
                            variant="outlined"
                            color="error"
                            fullWidth
                            onClick={handleCloseCamera}
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Stack>
            </ScannerCard>
        </Container>
    );
};

export default QrScanner;
